import { tlRouter, tlStore } from "../CorBase/CoreBase";
import { UserService } from "../../Services/CorBase/AllCorServices";

export function logoutCurrentUser(errorMessage: string = '') {
	let userService = new UserService();
	tlStore.commit('clearLastRoutePage');

	var formData = {
		id: tlStore.state.idUser
	}
	userService.loginOut(formData);
	// VaP - tato prvni verze nefunguje s params
	//tlRouter.push({ path: loginPage, query: { errorMessagexxx: errorMessage } });
	tlRouter.push({ name: "Login", params: { errorMessage: errorMessage } });
}